import React, {useState} from 'react'
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import { useForm } from "react-hook-form";
import { connect, useSelector } from "react-redux";

import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import { PH_CODE } from "../../../components/i18n/placeHolders";
import { FL_CODE, FL_ONLY_REGISTERED } from "../../../components/i18n/formLabels";
import { getStateByPath } from "../../../redux/selectors";
import { LB_ACTIVE } from "../../../components/i18n/i18n";
import { setFilter } from "../../../redux/actions/generics/IndexedActions";

const AybCategoryFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, category, userIsAdmin } = componentState?.data || {};

    const [status, setStatus] = useState(filter?.item?.status || null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item :  {
                ...data,
                category : category,
                status : status
            }
        };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        setOnlyRegistered(true)
        reset({
            code: ''
        });
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                    {
                        userIsAdmin ?
                            <Col md="3">
                                <FormGroup>
                                    <Label>{FL_ONLY_REGISTERED}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={onlyRegistered}
                                        onChange={() => setOnlyRegistered(!onlyRegistered)}
                                    />
                                </FormGroup>
                            </Col> : null
                    }
                    <Col sm={12} className={'d-flex justify-content-center'}>
                        <div className="float-right ">
                            <ButtonSearch/>
                            <ButtonClean onClick={cleanFields}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = _ => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(AybCategoryFilters)